import { Spinner, SpinnerProps } from 'reactstrap';
import './Pending.scss';

const Pending = (sProps: SpinnerProps) => (
    <div className="pending-container" data-testid="pending">
        <Spinner {...sProps} />
    </div>
);

export default Pending;
